import { ConfigureStore } from './configureStore'

const store = ConfigureStore();

export default store;